import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { createContext, useContext, useReducer } from 'react';
import axios from 'axios';
import * as moment from 'moment';
import { CAPABILITY_DENIAL_CODE } from '../constants/errorConstants';
export var MeetingContext = /*#__PURE__*/ createContext({
    fetchMeetings: function fetchMeetings(param) {
        var _param_showMore = param.showMore, showMore = _param_showMore === void 0 ? false : _param_showMore, _param_renewMeetings = param.renewMeetings, renewMeetings = _param_renewMeetings === void 0 ? true : _param_renewMeetings, _param_weekStartDate = param.weekStartDate, weekStartDate = _param_weekStartDate === void 0 ? moment().startOf('isoWeek') : _param_weekStartDate, _param_weekEndDate = param.weekEndDate, weekEndDate = _param_weekEndDate === void 0 ? moment().startOf('isoWeek').add(4, 'days') : _param_weekEndDate, _param_showMoreMode = param.showMoreMode, showMoreMode = _param_showMoreMode === void 0 ? 'upcoming' : _param_showMoreMode, _param_isModeSelectActive = param.isModeSelectActive, isModeSelectActive = _param_isModeSelectActive === void 0 ? false : _param_isModeSelectActive;
        return _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                return [
                    2
                ];
            });
        })();
    },
    getMeetings: function getMeetings() {
        return {
            meetings: [],
            upcomingMeetings: [],
            previousMeetings: [],
            upcomingGroupedMeetings: [],
            previousGroupedMeetings: [],
            groupedMeetings: []
        };
    },
    refreshMeetings: function refreshMeetings(param) {
        var _param_weekStartDate = param.weekStartDate, weekStartDate = _param_weekStartDate === void 0 ? moment().startOf('isoWeek') : _param_weekStartDate, _param_weekEndDate = param.weekEndDate, weekEndDate = _param_weekEndDate === void 0 ? moment().startOf('isoWeek').add(4, 'days') : _param_weekEndDate;
        return _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                return [
                    2
                ];
            });
        })();
    },
    expandMeetingsRange: function expandMeetingsRange(param) {
        var _param_weekStartDate = param.weekStartDate, weekStartDate = _param_weekStartDate === void 0 ? moment().startOf('isoWeek') : _param_weekStartDate, _param_weekEndDate = param.weekEndDate, weekEndDate = _param_weekEndDate === void 0 ? moment().startOf('isoWeek').add(4, 'days') : _param_weekEndDate;
        return _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                return [
                    2
                ];
            });
        })();
    },
    getInitialMeetings: function getInitialMeetings() {},
    getUpcomingMeetings: function getUpcomingMeetings() {},
    getIsLoading: function getIsLoading() {
        return true;
    },
    getIsModuleActive: function getIsModuleActive() {
        return true;
    },
    getGraphError: function getGraphError() {
        return true;
    },
    getGraphErrorText: function getGraphErrorText() {
        return '';
    },
    getGraphErrorCode: function getGraphErrorCode() {
        return '';
    },
    getIsInitialized: function getIsInitialized() {
        return true;
    },
    resetMeetings: function resetMeetings() {},
    getMeetingFilterSettings: function getMeetingFilterSettings() {
        return {
            enableMeetingKeyword: false,
            meetingFilterKeywords: []
        };
    },
    removeMeetingInstance: function removeMeetingInstance(meetingId) {},
    removeMeetingOccurrence: function removeMeetingOccurrence(seriesMasterId) {},
    addTalkingPointToMeeting: function addTalkingPointToMeeting(meetingId) {},
    removeTalkingPointFromMeeting: function removeTalkingPointFromMeeting(meetingId) {},
    state: {
        meetings: [],
        isLoading: false,
        limitStartDate: moment().startOf('isoWeek'),
        limitEndDate: moment().startOf('isoWeek').add(4, 'days'),
        enableMeetingKeyword: false,
        meetingFilterKeywords: [],
        upcomingMeetings: [],
        previousMeetings: [],
        groupedMeetings: [],
        upcomingGroupedMeetings: [],
        previousGroupedMeetings: [],
        graphError: false,
        graphErrorText: '',
        graphErrorCode: '',
        isModuleActive: true,
        isInitialized: false
    }
});
var reducer = function reducer(state, action) {
    switch(action.type){
        case 'set-meetings':
            {
                var _action_meetings;
                var newState = _object_spread({}, state);
                newState.meetings = (_action_meetings = action.meetings) !== null && _action_meetings !== void 0 ? _action_meetings : [];
                var upcomingMeetings = newState.meetings.filter(function(event) {
                    return moment(event.startDateTime).startOf('day').isSameOrAfter(moment().startOf('day'));
                });
                var previousMeetings = newState.meetings.filter(function(event) {
                    return moment(event.startDateTime).startOf('day').isSameOrBefore(moment().startOf('day'));
                }).sort(function(a, b) {
                    return moment(b.startDateTime).diff(moment(a.startDateTime));
                });
                newState.upcomingMeetings = upcomingMeetings;
                newState.previousMeetings = previousMeetings;
                newState.groupedMeetings = groupByDate(newState.meetings);
                newState.upcomingGroupedMeetings = groupByDate(upcomingMeetings);
                newState.previousGroupedMeetings = groupByDate(previousMeetings);
                return newState;
            }
        case 'update-meetings':
            {
                var _action_meetings1;
                var newState1 = _object_spread({}, state);
                newState1.meetings = newState1.meetings.concat((_action_meetings1 = action.meetings) !== null && _action_meetings1 !== void 0 ? _action_meetings1 : []).filter(function(currentValue, index, arr) {
                    return arr.findIndex(function(e) {
                        return e.meetingId === currentValue.meetingId;
                    }) === index;
                });
                var upcomingMeetings1 = newState1.meetings.filter(function(event) {
                    return moment(event.startDateTime).startOf('day').isSameOrAfter(moment().startOf('day'));
                });
                var previousMeetings1 = newState1.meetings.filter(function(event) {
                    return moment(event.startDateTime).startOf('day').isSameOrBefore(moment().startOf('day'));
                }).sort(function(a, b) {
                    return moment(b.startDateTime).diff(moment(a.startDateTime));
                });
                newState1.upcomingMeetings = upcomingMeetings1;
                newState1.previousMeetings = previousMeetings1;
                newState1.groupedMeetings = groupByDate(newState1.meetings);
                newState1.upcomingGroupedMeetings = groupByDate(upcomingMeetings1);
                newState1.previousGroupedMeetings = groupByDate(previousMeetings1);
                return newState1;
            }
        case 'set-loading':
            {
                var newState2 = _object_spread({}, state);
                newState2.isLoading = action.loading;
                return newState2;
            }
        case 'set-limit-dates':
            {
                var newState3 = _object_spread({}, state);
                newState3.limitStartDate = action.limitStartDate;
                newState3.limitEndDate = action.limitEndDate;
                return newState3;
            }
        case 'set-meeting-keywords':
            {
                var newState4 = _object_spread({}, state);
                newState4.enableMeetingKeyword = action.enableMeetingKeyword;
                newState4.meetingFilterKeywords = action.meetingFilterKeywords;
                return newState4;
            }
        case 'set-upcoming-meetings':
            {
                var newState5 = _object_spread({}, state);
                newState5.upcomingMeetings = action.upcomingMeetings;
                newState5.upcomingGroupedMeetings = groupByDate(action.upcomingMeetings);
                return newState5;
            }
        case 'set-previous-meetings':
            {
                var newState6 = _object_spread({}, state);
                newState6.previousMeetings = action.previousMeetings;
                newState6.previousGroupedMeetings = groupByDate(action.previousMeetings);
                return newState6;
            }
        case 'set-graph-error':
            {
                var newState7 = _object_spread({}, state);
                newState7.graphError = action.graphError;
                newState7.graphErrorText = action.graphErrorText;
                newState7.isLoading = action.isLoading;
                newState7.graphErrorCode = action.graphErrorCode;
                return newState7;
            }
        case 'set-is-module-active':
            {
                var newState8 = _object_spread({}, state);
                newState8.isModuleActive = action.isModuleActive;
                return newState8;
            }
        case 'set-is-initialized':
            {
                var newState9 = _object_spread({}, state);
                newState9.isInitialized = action.isInitialized;
                return newState9;
            }
        case 'reset-state':
            {
                return action.initialState;
            }
    }
};
var staticRequestLoadingState = {
    meetings: {}
};
var MeetingContextProvider = function MeetingContextProvider(props) {
    // #region Reducer =================================================================
    var _useReducer = _sliced_to_array(useReducer(reducer, {
        meetings: [],
        isLoading: false,
        limitStartDate: moment().startOf('isoWeek'),
        limitEndDate: moment().startOf('isoWeek').add(4, 'days'),
        enableMeetingKeyword: false,
        meetingFilterKeywords: [],
        upcomingMeetings: [],
        previousMeetings: [],
        groupedMeetings: [],
        upcomingGroupedMeetings: [],
        previousGroupedMeetings: [],
        graphError: false,
        graphErrorText: '',
        isModuleActive: true,
        isInitialized: false
    }), 2), state = _useReducer[0], dispatch = _useReducer[1];
    var resetMeetings = function resetMeetings() {
        dispatch({
            type: 'reset-state',
            initialState: {
                meetings: [],
                isLoading: false,
                limitStartDate: moment().startOf('isoWeek'),
                limitEndDate: moment().startOf('isoWeek').add(4, 'days'),
                enableMeetingKeyword: false,
                meetingFilterKeywords: [],
                upcomingMeetings: [],
                previousMeetings: [],
                groupedMeetings: [],
                upcomingGroupedMeetings: [],
                previousGroupedMeetings: [],
                graphError: false,
                graphErrorText: '',
                graphErrorCode: '',
                isModuleActive: true,
                isInitialized: false
            }
        });
    };
    // #endregion
    // #region Mounting Functions ==============================================================
    var fetchMeetings = function fetchMeetings(param) {
        var _param_showMore = param.showMore, showMore = _param_showMore === void 0 ? false : _param_showMore, _param_renewMeetings = param.renewMeetings, renewMeetings = _param_renewMeetings === void 0 ? true : _param_renewMeetings, _param_weekStartDate = param.weekStartDate, weekStartDate = _param_weekStartDate === void 0 ? moment().startOf('isoWeek') : _param_weekStartDate, _param_weekEndDate = param.weekEndDate, weekEndDate = _param_weekEndDate === void 0 ? moment().startOf('isoWeek').add(4, 'days') : _param_weekEndDate, _param_showMoreMode = param.showMoreMode, showMoreMode = _param_showMoreMode === void 0 ? 'upcoming' : _param_showMoreMode, _param_isModeSelectActive = param.isModeSelectActive, isModeSelectActive = _param_isModeSelectActive === void 0 ? false : _param_isModeSelectActive;
        return _async_to_generator(function() {
            var localStartDate, localEndDate;
            return _ts_generator(this, function(_state) {
                localStartDate = moment(weekStartDate);
                localEndDate = moment(weekEndDate);
                dispatch({
                    type: 'set-loading',
                    loading: true
                });
                if (showMore) {
                    if (showMoreMode === 'past') {
                        localStartDate = moment(state.limitStartDate).subtract(7, 'days');
                        localEndDate = moment(state.limitEndDate).subtract(7, 'days');
                        dispatch({
                            type: 'set-limit-dates',
                            limitStartDate: localStartDate,
                            limitEndDate: localEndDate
                        });
                    } else {
                        localStartDate = moment(state.limitStartDate).add(7, 'days');
                        localEndDate = moment(state.limitEndDate).add(7, 'days');
                        dispatch({
                            type: 'set-limit-dates',
                            limitStartDate: localStartDate,
                            limitEndDate: localEndDate
                        });
                    }
                }
                return [
                    2,
                    axios.post('/api/oneonone/getAllMeetings', {
                        mode: showMoreMode,
                        timezoneOffset: moment().utcOffset(),
                        startDate: localStartDate.format('YYYY-MM-DD'),
                        endDate: localEndDate.format('YYYY-MM-DD'),
                        isModeSelectActive: isModeSelectActive
                    }).then(function(response) {
                        var _response_data_enableMeetingKeyword, _response_data_meetingFilterKeywords;
                        dispatch({
                            type: 'set-meeting-keywords',
                            enableMeetingKeyword: (_response_data_enableMeetingKeyword = response.data.enableMeetingKeyword) !== null && _response_data_enableMeetingKeyword !== void 0 ? _response_data_enableMeetingKeyword : false,
                            meetingFilterKeywords: (_response_data_meetingFilterKeywords = response.data.meetingFilterKeywords) !== null && _response_data_meetingFilterKeywords !== void 0 ? _response_data_meetingFilterKeywords : []
                        });
                        var events = response.data.events;
                        var processedEvents = state.meetings;
                        if (renewMeetings) {
                            processedEvents = events;
                            dispatch({
                                type: 'set-meetings',
                                meetings: processedEvents
                            });
                        } else {
                            processedEvents = state.meetings.concat(events).filter(function(currentValue, index, arr) {
                                return arr.findIndex(function(e) {
                                    return e.meetingId === currentValue.meetingId;
                                }) === index;
                            });
                            dispatch({
                                type: 'update-meetings',
                                meetings: processedEvents
                            });
                        }
                        dispatch({
                            type: 'set-is-initialized',
                            isInitialized: true
                        });
                    }).catch(function(error) {
                        var _error_response, _error_response1, _error_response2;
                        console.log('err : ', error);
                        var errorData = error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.data;
                        var errorBody = (errorData === null || errorData === void 0 ? void 0 : errorData.body) ? JSON.parse(errorData.body) : null;
                        var errorCode = (errorBody === null || errorBody === void 0 ? void 0 : errorBody.code) || (errorData === null || errorData === void 0 ? void 0 : errorData.code);
                        var errorMessage = (errorBody === null || errorBody === void 0 ? void 0 : errorBody.message) || (errorData === null || errorData === void 0 ? void 0 : errorData.message);
                        // Viewer has no meetings capability (external user, backend 403) — a terminal
                        // state, not a transient error: mark initialized so surfaces clear the skeleton
                        // to their empty states, and leave graphError unset so the allow-access page
                        // never renders for externals.
                        if (errorCode === CAPABILITY_DENIAL_CODE) {
                            dispatch({
                                type: 'set-is-initialized',
                                isInitialized: true
                            });
                            return;
                        }
                        if (errorCode === 'ErrorAccessDenied') {
                            dispatch({
                                type: 'set-graph-error',
                                graphError: true,
                                graphErrorText: errorMessage,
                                graphErrorCode: errorCode,
                                isLoading: false
                            });
                            return;
                        }
                        if (((_error_response1 = error.response) === null || _error_response1 === void 0 ? void 0 : _error_response1.status) === 500) {
                            if (errorCode === 'MailboxNotEnabledForRESTAPI') {
                                dispatch({
                                    type: 'set-graph-error',
                                    graphError: true,
                                    graphErrorText: errorMessage,
                                    graphErrorCode: errorCode,
                                    isLoading: false
                                });
                            } else {
                                dispatch({
                                    type: 'set-graph-error',
                                    graphError: false,
                                    graphErrorText: '',
                                    isLoading: false
                                });
                            }
                        } else if ((error === null || error === void 0 ? void 0 : (_error_response2 = error.response) === null || _error_response2 === void 0 ? void 0 : _error_response2.status) === 401) {
                            // Disabled from tenant
                            dispatch({
                                type: 'set-is-module-active',
                                isModuleActive: false
                            });
                        }
                        // Every non-consent failure is terminal for this fetch: mark initialized so no
                        // error shape leaves the skeleton/spinner forever (ErrorAccessDenied returned
                        // above — its surfaces render the allow-access page keyed on the code).
                        dispatch({
                            type: 'set-is-initialized',
                            isInitialized: true
                        });
                    }).finally(function() {
                        dispatch({
                            type: 'set-loading',
                            loading: false
                        });
                    })
                ];
            });
        })();
    };
    //#endregion
    // #region Getter Functions ================================================================
    var getMeetings = function getMeetings() {
        return {
            meetings: state.meetings,
            groupedMeetings: state.groupedMeetings,
            upcomingMeetings: state.upcomingMeetings,
            previousMeetings: state.previousMeetings,
            upcomingGroupedMeetings: state.upcomingGroupedMeetings,
            previousGroupedMeetings: state.previousGroupedMeetings
        };
    };
    var refreshMeetings = function refreshMeetings(param) {
        var _param_weekStartDate = param.weekStartDate, weekStartDate = _param_weekStartDate === void 0 ? moment().startOf('isoWeek') : _param_weekStartDate, _param_weekEndDate = param.weekEndDate, weekEndDate = _param_weekEndDate === void 0 ? moment().startOf('isoWeek').add(4, 'days') : _param_weekEndDate;
        return _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!state.isInitialized) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            fetchMeetings({
                                weekStartDate: weekStartDate,
                                weekEndDate: weekEndDate,
                                renewMeetings: false
                            })
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    var expandMeetingsRange = function expandMeetingsRange(param) {
        var _param_weekStartDate = param.weekStartDate, weekStartDate = _param_weekStartDate === void 0 ? moment().startOf('isoWeek') : _param_weekStartDate, _param_weekEndDate = param.weekEndDate, weekEndDate = _param_weekEndDate === void 0 ? moment().startOf('isoWeek').add(4, 'days') : _param_weekEndDate;
        return _async_to_generator(function() {
            var limitStartDate, limitEndDate, newLimitStartDate, newLimitEndDate, shouldRefresh;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        limitStartDate = state.limitStartDate;
                        limitEndDate = state.limitEndDate;
                        newLimitStartDate = limitStartDate;
                        newLimitEndDate = limitEndDate;
                        shouldRefresh = false;
                        if (moment(weekStartDate).isBefore(limitStartDate)) {
                            newLimitStartDate = weekStartDate;
                            shouldRefresh = true;
                        }
                        if (moment(weekEndDate).isAfter(limitEndDate)) {
                            newLimitEndDate = weekEndDate;
                            shouldRefresh = true;
                        }
                        if (limitStartDate !== newLimitStartDate || limitEndDate !== newLimitEndDate) {
                            dispatch({
                                type: 'set-limit-dates',
                                limitStartDate: newLimitStartDate,
                                limitEndDate: newLimitEndDate
                            });
                        }
                        if (!shouldRefresh) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            fetchMeetings({
                                weekStartDate: weekStartDate,
                                weekEndDate: weekEndDate,
                                renewMeetings: false
                            })
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    var getInitialMeetings = function getInitialMeetings() {
        getUpcomingMeetings();
        fetchMeetings({});
    };
    var getUpcomingMeetings = function getUpcomingMeetings() {
        fetchMeetings({
            weekStartDate: moment(),
            weekEndDate: moment(),
            renewMeetings: true,
            isModeSelectActive: true
        });
        return state.upcomingMeetings;
    };
    var getIsLoading = function getIsLoading() {
        return state.isLoading;
    };
    var getIsModuleActive = function getIsModuleActive() {
        return state.isModuleActive;
    };
    var getGraphError = function getGraphError() {
        return state.graphError;
    };
    var getGraphErrorText = function getGraphErrorText() {
        return state.graphErrorText;
    };
    var getGraphErrorCode = function getGraphErrorCode() {
        return state.graphErrorCode;
    };
    var getIsInitialized = function getIsInitialized() {
        return state.isInitialized;
    };
    var getMeetingFilterSettings = function getMeetingFilterSettings() {
        return {
            enableMeetingKeyword: state.enableMeetingKeyword,
            meetingFilterKeywords: state.meetingFilterKeywords
        };
    };
    // #endregion
    // #region Setter Functions ================================================================
    var removeMeetingInstance = function removeMeetingInstance(meetingId) {
        var meetings = state.meetings.filter(function(m) {
            return m.meetingId !== meetingId;
        });
        dispatch({
            type: 'set-meetings',
            meetings: meetings
        });
    };
    var removeMeetingOccurrence = function removeMeetingOccurrence(seriesMasterId) {
        var meetings = state.meetings.filter(function(m) {
            return m.seriesMasterId !== seriesMasterId;
        });
        dispatch({
            type: 'set-meetings',
            meetings: meetings
        });
    };
    var addTalkingPointToMeeting = function addTalkingPointToMeeting(meetingId) {
        var meetings = _to_consumable_array(state.meetings);
        // find the meeting
        var meeting = state.meetings.find(function(m) {
            return m.meetingId === meetingId;
        });
        // increase talkingPointNumber by 1
        if (meeting) {
            if (!meeting.talkingPointNumber) {
                meeting.talkingPointNumber = 1;
            } else {
                meeting.talkingPointNumber++;
            }
        }
        dispatch({
            type: 'set-meetings',
            meetings: meetings
        });
    };
    var removeTalkingPointFromMeeting = function removeTalkingPointFromMeeting(meetingId) {
        var meetings = _to_consumable_array(state.meetings);
        // find the meeting by meetingId regex
        var meeting = state.meetings.find(function(m) {
            return m.meetingId.match(meetingId);
        });
        // decrease talkingPointNumber by 1
        if (meeting) {
            if (meeting.talkingPointNumber) {
                meeting.talkingPointNumber--;
            }
        }
        dispatch({
            type: 'set-meetings',
            meetings: meetings
        });
    };
    // #endregion
    return /*#__PURE__*/ _jsx(MeetingContext.Provider, {
        value: {
            fetchMeetings: fetchMeetings,
            getMeetings: getMeetings,
            refreshMeetings: refreshMeetings,
            expandMeetingsRange: expandMeetingsRange,
            getInitialMeetings: getInitialMeetings,
            getUpcomingMeetings: getUpcomingMeetings,
            getIsLoading: getIsLoading,
            getIsModuleActive: getIsModuleActive,
            getGraphError: getGraphError,
            getGraphErrorText: getGraphErrorText,
            getGraphErrorCode: getGraphErrorCode,
            getIsInitialized: getIsInitialized,
            resetMeetings: resetMeetings,
            getMeetingFilterSettings: getMeetingFilterSettings,
            removeMeetingInstance: removeMeetingInstance,
            removeMeetingOccurrence: removeMeetingOccurrence,
            addTalkingPointToMeeting: addTalkingPointToMeeting,
            removeTalkingPointFromMeeting: removeTalkingPointFromMeeting,
            state: state
        },
        children: props.children
    });
};
//#region Helper Functions =================================================================
var groupByDate = function groupByDate(meetings) {
    var groupsMap = new Map();
    meetings.forEach(function(meeting, i) {
        var date = meeting.startStr;
        if (!groupsMap.has(date)) {
            groupsMap.set(date, {
                key: "".concat(date, ",").concat(i),
                name: date,
                count: 1,
                data: {
                    fullCount: 1
                },
                hasMoreData: false,
                startIndex: 0
            });
        } else {
            var existingGroup = groupsMap.get(date);
            existingGroup.count++;
            existingGroup.data.fullCount++;
        }
    });
    var groups = Array.from(groupsMap.values());
    var cumulativeIndex = 0;
    groups.forEach(function(group) {
        group.startIndex = cumulativeIndex;
        cumulativeIndex += group.count;
    });
    return groups;
};
//#endregion
var useMeeting = function useMeeting() {
    return useContext(MeetingContext);
};
export { MeetingContextProvider, useMeeting };
